import Vue from 'vue';
import { bufferTime } from 'rxjs/internal/operators/bufferTime';
import { Observable } from 'rxjs/internal/Observable';

const impressionService = {
    observer: undefined,
    addImpression(impression) {
        if (!this.observer) {
            const impressionsObservable = new Observable(observer => {
                this.observer = observer;
            }).pipe(bufferTime(500));
            impressionsObservable.subscribe({
                next(impressions) {
                    if (impressions.length) {
                        let i = 0;
                        const data = impressions.map(impression => {
                            impression.position = ++i;
                            return impression;
                        });

                        // UA
                        Vue.$gtm.push({
                            event: 'productListView',
                            ecommerce: {
                                impressions: data,
                            },
                        });

                        // GA4
                        Vue.$gtm.push({
                            event: 'view_item_list',
                            ecommerce: {
                                items: data,
                            },
                        });
                    }
                },
            });
        }
        this.observer.next(impression);
    },
};

export const onProductPreview = (product, target) => {
    impressionService.addImpression({
        ...Vue.$gtm.getProductObject(product),
        list: target,
    });
};
